package net.frozenbit.games.soundgame.ui

import androidx.compose.foundation.text.input.InputTransformation
import androidx.compose.foundation.text.input.TextFieldState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.State
import androidx.compose.runtime.getValue
import net.frozenbit.games.soundgame.utils.Countdown
import net.frozenbit.games.soundgame.viewmodels.ControllerViewModel

@Composable
fun ControllerScreen(
    controllerUiState: ControllerViewModel.ControllerUiState,
    joinCodeState: TextFieldState,
    joinCodeTransformation: InputTransformation,
    playerNameState: TextFieldState,
    selectedAvatarIndex: Int?,
    countdownTextState: State<Countdown.Tick?>,
    onJoinGameClick: () -> Unit,
    onStartButtonClick: () -> Unit,
    onAvatarSelected: (Int) -> Unit,
    onPromptSelected: (Int) -> Unit,
    onSoundSelected: (Int) -> Unit,
    onVoteSelected: (Int) -> Unit,
    onReplayClicked: (Int) -> Unit,
    onGameOverActionSelected: (Int) -> Unit,
) {
    val countdownText by countdownTextState
    when (controllerUiState) {
        is ControllerViewModel.ControllerUiState.Idle -> {
            ControllerPreGameScreen(
                joinCodeState = joinCodeState,
                joinCodeTransformation = joinCodeTransformation,
                controllerUiState = controllerUiState,
                playerNameState = playerNameState,
                loading = controllerUiState.loading,
                onJoinGameClick = onJoinGameClick,
            )
        }
        is ControllerViewModel.ControllerUiState.Lobby -> {
            ControllerLobbyScreen(
                showStartButton = controllerUiState.showStartButton,
                enableStartButton = controllerUiState.enableStartButton,
                selectedAvatarIndex = selectedAvatarIndex,
                onStartButtonClicked = onStartButtonClick,
                onAvatarSelected = onAvatarSelected,
            )
        }

        is ControllerViewModel.ControllerUiState.PromptSelection -> {
            ControllerPromptSelectionScreen(
                options = controllerUiState.optionTexts,
                onPromptSelected = { onPromptSelected(it) },
            )
        }

        ControllerViewModel.ControllerUiState.Waiting -> {
            ControllerWaitScreen()
        }

        is ControllerViewModel.ControllerUiState.SoundSelection -> {
            ControllerSoundSelectionScreen(
                soundOptions = controllerUiState.soundOptions,
                lockInTimeout = controllerUiState.lockInTimeout,
                onSoundSelected = { onSoundSelected(it) },
            )
        }

        is ControllerViewModel.ControllerUiState.Voting -> {
            ControllerVotingScreen(
                options = controllerUiState.voteOptions,
                onVoteSelected = { onVoteSelected(it) },
                onReplayClicked = { onReplayClicked(it) },
            )
        }

        is ControllerViewModel.ControllerUiState.GameOver -> {
            ControllerGameOverScreen(
                actionTexts = controllerUiState.actionTexts,
                onActionClick = { onGameOverActionSelected(it) }
            )
        }
    }
}

